import { PortalUnitsInfiniteView } from '@apps-common/apps/portal/pages/units/components/portal/units-infinite'
import { PortalUnitsTableView } from '@apps-common/apps/portal/pages/units/components/portal/units-table'
import { MobileViewSwitcher } from '@apps-common/components/common/MobileViewSwitcher'

export const PortalUnitsView = () => <MobileViewSwitcher desktopView={<PortalUnitsTableView />} mobileView={<PortalUnitsInfiniteView />} />
